import WelcomeInfo from '@/app/modules/toolkit/common/components/welcome-info/welcome-info.vue';

export default {
  name: 'inv-strat-review-welcome-container',
  components: {
    WelcomeInfo,
  },
  data: () => ({
    infos: [
      {
        title: 'What is this service for?',
        text: 'SMSF trustees must not only formulate an Investment Strategy but they must also ensure it is regularly reviewed.  This service is used to request a document package to record the review of an Investment Strategy where the trustee has decided to keep the existing strategy in place. (Where the trustee has decided to change the strategy, the Investment Strategy service should be used to create new documentation.)',
        icon: 'icon-link',
      },
      {
        title: 'What if I need help?',
        text:
          'If you need assistance with this form, then please either call on 1300 HEFFRON or send an email to clientsupport@heffron.com.au.',
        icon: 'icon-help',
      },
      {
        title: 'Who is this service for?',
        text: 'This service is for accountants and advisers to use with their clients. It helps accountants, advisers and trustees to articulate the reasons for keeping their current strategy in a way that will make it clear to the ATO and auditors that all relevant risks, changes in fund circumstances and external influences have been considered.',
        icon: 'icon-group',
      },
      {
        title: 'What does it contain?',
        text: 'Investment Strategy Review Packages include a resolution to retain the existing strategy that documents the issues considered in making this decision.',
        icon: 'icon-folder',
      },
    ],
    currentStep: 0,
    stepperData: {
      title: 'Investment Strategy Review',
      style: 'blue',
      steps: [
        {
          step: 1,
          name: 'Welcome',
          component: '',
        },
        {
          step: 2,
          name: 'Investment Strategy Last Review',
          component: '',
        },
        {
          step: 3,
          name: 'Investment Strategy Review',
          component: '',
        },
        {
          step: 4,
          name: 'Review & Complete',
          component: '',
        },
      ],
    },
  }),
  methods: {
    handleStart() {
      this.$router.push('/fund/information').catch(() => {});
    },
    handleCancel() {
      this.$mixpanel.track('Toolkit Item', {
        action: 'Cancel',
        status: 'Started',
        type: 'INVESTMENT_STRATEGY_REVIEW',
      });
      this.$router.push('/toolkit/investment-strategy-review/dashboard').catch(() => {});
    },
  },
};
